import styled from 'styled-components';
import { useEffect, useState } from 'react';

import { Button } from 'shared/components/Button';
import { useCheckoutContext } from 'checkout/providers/CheckoutContextProvider';
import { GiftCard } from 'checkout/components/Payment/GiftCard';
import { t } from 'localization/utils/t';

const TP = 'checkout.components.Payment.PayPal';

export const PayPal = () => {
  const [isPayPalSuccessful, setIsPayPalSuccessful] = useState<boolean>(false);

  const { initBraintree, braintreeClient } = useCheckoutContext();

  useEffect(() => {
    void initBraintree(() => setIsPayPalSuccessful(true));
  }, [initBraintree]);

  const handleContinue = () => {
    braintreeClient?.paypal.initAuthFlow();
  };

  return (
    <>
      <PayPal.Wrapper>
        <GiftCard />
        <p>
          {t(
            `${TP}.paypalInstructions`,
            'You will be redirected to PayPal to provide your payment information before returning to GOAT to complete your order.',
          )}
        </p>
        <Button
          data-qa="checkout_continue_paypal"
          loading={!braintreeClient}
          disabled={!braintreeClient || isPayPalSuccessful}
          onClick={handleContinue}
        >
          {braintreeClient && t(`${TP}.continuePayPalButton`, 'Continue to PayPal')}
        </Button>
      </PayPal.Wrapper>
    </>
  );
};

PayPal.Wrapper = styled.div`
  width: 100%;
  p {
    margin-bottom: 16px;
  }
`;

PayPal.Link = styled.a`
  text-decoration: underline;
`;
